export enum PropertyType {
	Occupation = 'occupation',
	PurposeOfDeposit = 'purposeOfDeposit',
	MoneySource = 'moneySource',
	TaxCountry = 'taxCountry',
	ExpectedDeposits = 'expectedDeposits',
	ExpectedDepositsAmount = 'expectedDepositsAmount',
	ExpectedWithdrawls = 'expectedWithdrawals',
	ExpectedWithdrawlsAmount = 'expectedWithdrawalsAmount',
	IdentificationType = 'identificationType',
	Income = 'income',
	IncomePayslipsCount = 'incomePayslipsCount',
	DepositOwner = 'depositOwner',
	PurposeOfLoan = 'purposeOfLoan',
	MaritalStatus = 'maritalStatus',
	AccommodationType = 'accommodationType',
	Education = 'education',
	EmploymentSector = 'employmentSector',
	PermitType = 'permitType',
	EmployedSincePeriod = 'employedSincePeriod',
	OccupationCategory = 'occupationCategory',
	EmploymentType = 'EmploymentType',
}
